var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMessagesIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40833 1.66667L1.4 11.6667C1.4 11.6668 1.4 11.6666 1.4 11.6667C1.40019 11.81 1.52331 11.9333 1.66667 11.9333H15C15.1435 11.9333 15.2667 11.8101 15.2667 11.6667V1.66667C15.2667 1.5232 15.1435 1.4 15 1.4H1.66667C1.53232 1.4 1.40833 1.51405 1.40833 1.66667ZM0.00833333 1.66667L0 11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H15C15.9167 13.3333 16.6667 12.5833 16.6667 11.6667V1.66667C16.6667 0.75 15.9167 0 15 0H1.66667C0.75 0 0.00833333 0.75 0.00833333 1.66667Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.389648 2.33226L1.27717 1.00098L8.33341 5.70514L15.3896 1.00098L16.2772 2.33226L8.33341 7.6281L0.389648 2.33226Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMessagesIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/messages_icon.cceb26c5.svg";
export { ForwardRef as ReactComponent };